function toggleMenu() {
  const toggle = document.querySelector('#menuToggle')
  const body = document.querySelector('body')
  const nav = document.querySelector('#mainNav')
  const open = document.querySelector('.menu-open')
  const close = document.querySelector('.menu-close')

  toggle.addEventListener('click', () => {
    body.classList.toggle('overflow-hidden')
    nav.classList.toggle('opacity-0')
    nav.classList.toggle('pointer-events-none')
    open.classList.toggle('opacity-0')
    close.classList.toggle('opacity-0')
  })
}

export default toggleMenu
